import { gql } from "@apollo/client"
import { BulkCreatePaySupplementsInput, BulkCreatePaySupplementsPayload } from "@oysterhr/schema"
import { useMutation, InjectedOptions } from "@oysterhr/core"

interface Response {
  bulkCreatePaySupplements: BulkCreatePaySupplementsPayload
}

export const MUTATION = gql`
  mutation BulkCreatePaySupplements(
    $engagementId: String!
    $paySupplementId: String
    $paymentType: PaySupplementAvailablePaymentTypeEnum
    $amount: Float
    $notes: String
    $startingMonth: Int
    $startingYear: Int
    $endingMonth: Int
    $endingYear: Int
    $state: PaySupplementStateEnumType
  ) {
    bulkCreatePaySupplements(
      input: {
        engagementId: $engagementId
        paySupplementId: $paySupplementId
        paymentType: $paymentType
        amount: $amount
        notes: $notes
        startingMonth: $startingMonth
        startingYear: $startingYear
        endingMonth: $endingMonth
        endingYear: $endingYear
        state: $state
      }
    ) {
      errors
    }
  }
`

export const useBulkCreatePaySupplements = (
  options?: InjectedOptions<Response, BulkCreatePaySupplementsInput>,
) => useMutation<Response, BulkCreatePaySupplementsInput>(MUTATION, options)
